var map = {
	"./LTC.svg": 840,
	"./V-round.svg": 841,
	"./account-check.svg": 842,
	"./achievement.svg": 843,
	"./add.svg": 682,
	"./aim.svg": 844,
	"./alarm.svg": 845,
	"./allow.svg": 299,
	"./angle-double-left.svg": 419,
	"./angle-left.svg": 194,
	"./angle-right.svg": 262,
	"./anticheat-circle.svg": 846,
	"./antichit-warning.svg": 847,
	"./arrow-down.svg": 300,
	"./arrow-left.svg": 301,
	"./arrow-right.svg": 264,
	"./arrow-up-right.svg": 848,
	"./arrow-up.svg": 849,
	"./attention.svg": 420,
	"./auth_discord.svg": 850,
	"./auth_facebook.svg": 851,
	"./auth_google.svg": 852,
	"./auth_steam.svg": 853,
	"./auth_vk.svg": 854,
	"./berserk.svg": 855,
	"./bitcoin.svg": 683,
	"./blog.svg": 856,
	"./bona.svg": 857,
	"./bonusWarning.svg": 858,
	"./bookmark.svg": 859,
	"./bulb.svg": 684,
	"./calendar.svg": 347,
	"./call.svg": 421,
	"./cam-circle.svg": 685,
	"./cam.svg": 860,
	"./cells.svg": 861,
	"./chart-down.svg": 422,
	"./chart.svg": 686,
	"./chat.svg": 218,
	"./chatvvv.svg": 666,
	"./checkmark-blue.svg": 862,
	"./checkmark-double-green.svg": 687,
	"./checkmark-green-plain.svg": 662,
	"./checkmark-green.svg": 341,
	"./checkmark-red.svg": 863,
	"./checkmark-white.svg": 669,
	"./checkmark.svg": 423,
	"./close-red.svg": 688,
	"./close.svg": 169,
	"./coins-gold.svg": 302,
	"./coins-in-round.svg": 424,
	"./coins-new.svg": 689,
	"./coins-payout.svg": 425,
	"./coins-yellow.svg": 864,
	"./coins.svg": 260,
	"./colorpicker.svg": 865,
	"./combined.svg": 866,
	"./copy.svg": 663,
	"./cost.svg": 261,
	"./create.svg": 867,
	"./credit-card-sponsor.svg": 868,
	"./credit-card.svg": 869,
	"./crown.svg": 870,
	"./dashboard.svg": 871,
	"./denied.svg": 265,
	"./devices/android.svg": 426,
	"./devices/ios.svg": 427,
	"./devices/mac.svg": 428,
	"./devices/windows.svg": 429,
	"./diamond.svg": 430,
	"./discord.svg": 872,
	"./dislike.svg": 873,
	"./done-circle.svg": 690,
	"./dots.svg": 431,
	"./double-check.svg": 432,
	"./download.svg": 691,
	"./duration.svg": 874,
	"./earn.svg": 692,
	"./edit.svg": 667,
	"./email.svg": 875,
	"./enter.svg": 876,
	"./error-circle.svg": 693,
	"./error.svg": 433,
	"./euro.svg": 342,
	"./exit.svg": 668,
	"./eye-closed.svg": 877,
	"./eye.svg": 878,
	"./facebook.svg": 879,
	"./filter-arrow.svg": 196,
	"./filter.svg": 880,
	"./fixed.svg": 694,
	"./flag.svg": 881,
	"./gamepad.svg": 695,
	"./gamepad2.svg": 882,
	"./gear.svg": 696,
	"./gem.svg": 883,
	"./gift.svg": 884,
	"./giftAuth.svg": 885,
	"./globe.svg": 697,
	"./google.svg": 698,
	"./group.svg": 699,
	"./halfstar.svg": 434,
	"./heart.svg": 335,
	"./hide.svg": 670,
	"./home.svg": 886,
	"./info.svg": 134,
	"./instagram.svg": 887,
	"./keyboard.svg": 671,
	"./kill.svg": 435,
	"./leaderboard.svg": 436,
	"./level.svg": 888,
	"./like.svg": 437,
	"./link-extra.svg": 438,
	"./link.svg": 219,
	"./list.svg": 889,
	"./location.svg": 890,
	"./lock-open.svg": 348,
	"./lock.svg": 343,
	"./mail-support.svg": 439,
	"./mail.svg": 700,
	"./marketplace-delete.svg": 349,
	"./max-loses.svg": 891,
	"./medal.svg": 701,
	"./menu.svg": 892,
	"./min-players.svg": 702,
	"./minus.svg": 893,
	"./money.svg": 894,
	"./money_2_sponsor.svg": 895,
	"./money_sponsor.svg": 896,
	"./my-account.svg": 897,
	"./new-rating.svg": 660,
	"./nominations.svg": 703,
	"./not-fixed.svg": 704,
	"./notifications.svg": 898,
	"./offerwall.svg": 899,
	"./other.svg": 900,
	"./overwolf.svg": 705,
	"./participants.svg": 706,
	"./paypal.svg": 901,
	"./pending.svg": 707,
	"./phone.svg": 902,
	"./player-empty.svg": 303,
	"./players.svg": 440,
	"./plus.svg": 263,
	"./prize.svg": 903,
	"./protect.svg": 904,
	"./qiwi.svg": 905,
	"./question-mark-white.svg": 304,
	"./question-mark-yellow.svg": 659,
	"./rating.svg": 906,
	"./readed-mail.svg": 441,
	"./referral.svg": 350,
	"./refresh.svg": 442,
	"./reglament.svg": 907,
	"./round-currencies/coins.svg": 708,
	"./round-currencies/money.svg": 709,
	"./round-currencies/tickets.svg": 710,
	"./ru-card.svg": 908,
	"./sad.svg": 339,
	"./sale.svg": 711,
	"./santa-hat.svg": 443,
	"./sbp.svg": 909,
	"./search.svg": 910,
	"./security.svg": 911,
	"./send.svg": 912,
	"./settings.svg": 913,
	"./share.svg": 914,
	"./shield-user.svg": 915,
	"./shield.svg": 189,
	"./shop.svg": 444,
	"./shop_icon.svg": 916,
	"./sidebar.svg": 917,
	"./sign-in.svg": 418,
	"./smile-big.svg": 918,
	"./smile.svg": 919,
	"./star-gold.svg": 334,
	"./star-grey.svg": 665,
	"./star-round.svg": 920,
	"./star-small.svg": 921,
	"./star-v.svg": 922,
	"./star-violet.svg": 923,
	"./star-with-paddings.svg": 712,
	"./star.svg": 170,
	"./status.svg": 136,
	"./store.svg": 445,
	"./success.svg": 446,
	"./target.svg": 713,
	"./telegram-blue.svg": 672,
	"./telegram.svg": 220,
	"./tetris.svg": 924,
	"./thunder.svg": 447,
	"./ticket-big.svg": 925,
	"./ticket.svg": 926,
	"./tiktok.svg": 927,
	"./time-schedule.svg": 928,
	"./time.svg": 714,
	"./timer.svg": 929,
	"./top_sponsor.svg": 930,
	"./trash.svg": 673,
	"./triangle.svg": 661,
	"./trophy.svg": 664,
	"./twitch.svg": 344,
	"./twitter.svg": 931,
	"./twitter2.svg": 932,
	"./usd-card.svg": 933,
	"./user.svg": 305,
	"./v.svg": 338,
	"./verified.svg": 674,
	"./vk.svg": 934,
	"./wait.svg": 675,
	"./waiting.svg": 935,
	"./wallet-header.svg": 715,
	"./wallet.svg": 936,
	"./warning-2-red.svg": 716,
	"./warning-2.svg": 937,
	"./warning.svg": 199,
	"./webmoney.svg": 938,
	"./world.svg": 717,
	"./x2.svg": 718,
	"./youtube-white.svg": 939,
	"./youtube.svg": 345
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75;